// extracted by mini-css-extract-plugin
module.exports = {"repeat":"RefreshAnimated_repeat__y40_n","icon":"RefreshAnimated_icon__Ya_oZ","clicked":"RefreshAnimated_clicked__Y4ZLW","rotate":"RefreshAnimated_rotate__BV1se"};